import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../config/api"
export default function Tests() {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/tests`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch tests");
        return res.json();
      })
      .then((data) => {
        setTests(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-950 to-black text-white flex">
      
      {/* ================= SIDEBAR ================= */}
      <div className="w-72 bg-white/5 backdrop-blur-xl border-r border-gray-800 p-6">
        <h2 className="text-xl font-bold mb-6">📝 Test Center</h2>

        <div className="space-y-4 text-sm text-gray-400">
          <div className="p-4 rounded-xl bg-white/5 border border-gray-800">
            ⏱ Timed Assessments
          </div>
          <div className="p-4 rounded-xl bg-white/5 border border-gray-800">
            📊 Performance Based
          </div>
          <div className="p-4 rounded-xl bg-white/5 border border-gray-800">
            🛡 Secure Environment
          </div>
        </div>

        <div className="mt-10 p-4 rounded-xl border border-dashed border-gray-700 text-center text-gray-400">
          More test modes  
          <br />
          <span className="text-yellow-400 font-semibold">
            Coming Soon
          </span>
        </div>
      </div>

      {/* ================= MAIN CONTENT ================= */}
      <div className="flex-1 px-10 py-10">

        {/* HEADER */}
        <div className="max-w-5xl mx-auto mb-8">
          <h1 className="text-3xl font-bold">
            Available Tests
          </h1>
          <p className="text-gray-400 mt-1">
            Select a test and begin your assessment
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          {loading && (
            <div className="text-gray-400 animate-pulse">
              Loading tests...
            </div>
          )}

          {error && (
            <p className="text-red-400">{error}</p>
          )}

          {!loading && tests.length === 0 && (
            <div className="mt-16 text-center bg-white/5 border border-gray-800 rounded-2xl p-12">
              <div className="text-5xl mb-4">📭</div>
              <h3 className="text-xl font-semibold">
                No Active Tests
              </h3>
              <p className="text-gray-400 mt-2">
                New assessments will appear here once published.
              </p>
            </div>
          )}

          <div className="grid gap-6">
            {tests.map((test) => (
              <div
                key={test._id}
                className="bg-gray-900 border border-gray-800
                rounded-xl p-6 flex items-center justify-between
                hover:border-blue-500 transition"
              >
                {/* LEFT */}
                <div>
                  <h2 className="text-xl font-semibold">
                    {test.title}
                  </h2>
                  <p className="text-sm text-gray-400 mt-1">
                    ⏱ Duration: {test.duration} minutes
                  </p>
                </div>

                {/* RIGHT */}
                <button
                  onClick={() =>
                    navigate(`/tests/${test._id}/precheck`)
                  }
                  className="bg-blue-600 hover:bg-blue-700
                  px-6 py-3 rounded-lg font-semibold"
                >
                  Start Test →
                </button>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}
